import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import StateOfTheEconomy from '../../collection-templates/state-of-the-economy';
import { isEmpty } from 'lodash';

const StateOfTheEconomyFullWidget = (props) => {
  const [collectionData, setCollectionData] = useState({});
  const queryClient = new QueryClient;

  useEffect(() => {
    const getCollectionData = async () => {
      if (isEmpty(collectionData)) {
        try {
          const response = await fetch('https://www.ndtvprofit.com/api/v1/collections/state-of-the-economy').then(res => res.json());
          setCollectionData(response);
        } catch (e) {
          console.log('Error in api');
        }
      }
    }

    getCollectionData();
  })

  return (
    <QueryClientProvider client={queryClient}>
      {!isEmpty(collectionData) && (
        <StateOfTheEconomy
          collection={collectionData}
          widget={true}
          target="_parent"
          {...props}/>
      )}
    </QueryClientProvider>
  );
};

export { StateOfTheEconomyFullWidget };